import { Navigate, useLocation } from "react-router-dom";
import { useSSO } from "../context/AuthContext";
import Loader from "../components/layout/Loader";

const PrivateRoute = ({ Component }) => {
  const location = useLocation();

  const {
    authReady,
    isAuthenticated,
    interactionRequired,
    acquireApiTokenInteractively,
  } = useSSO();

  if (!authReady) {
    return <Loader />;
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/logout"
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  if (interactionRequired) {
    return (
      <div className="auth-required">
        <h2>Authentication required</h2>

        <p>
          Your session requires additional authentication before you can
          continue.
        </p>

        <button
          type="button"
          onClick={acquireApiTokenInteractively}
        >
          Continue sign-in
        </button>
      </div>
    );
  }

  return <Component />;
};

export default PrivateRoute;